var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAiAgents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    stroke: "#ececec",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 10.75C6.25 10.75 10.75 6.25 10.75 1.75C10.75 6.25 15.25 10.75 19.75 10.75C15.25 10.75 10.75 15.25 10.75 19.75C10.75 15.25 6.25 10.75 1.75 10.75Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 18.25C1.58333 18.25 3.25 16.5833 3.25 15.75C3.25 16.5833 4.91667 18.25 5.75 18.25C4.91667 18.25 3.25 19.9167 3.25 20.75C3.25 19.9167 1.58333 18.25 0.75 18.25Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 3.75C15.75 3.75 17.75 1.75 17.75 0.75C17.75 1.75 19.75 3.75 20.75 3.75C19.75 3.75 17.75 5.75 17.75 6.75C17.75 5.75 15.75 3.75 14.75 3.75Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAiAgents);
export default __webpack_public_path__ + "static/media/icon-ai-agents.a8514ffbae5699ae7f318151870dd35f.svg";
export { ForwardRef as ReactComponent };